module.exports = __webpack_public_path__ + "media/src/assets/Images/user-02-d582b62890f3619dda5c183a3d3d458c.svg";